.<template>
  <div>
    <div class="shaloiNoBranch">
      <div>
      <img src="../../assets/oops.png" alt="" /><br />
      </div>
      <div>
      <h5>
        You have not yet been assigned to Any branch. Contact your admin to asign you
        a branch
      </h5>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="css" scoped>
.shaloiNoBranch {
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
}
.shaloiNoBranch>div{
  display: flex;
  text-align: center;
  padding: 1em;
  justify-content: center;
  min-width: 51%;
}
</style>
